import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a98ac30ea0882b9b45a8ceb693ccd4dd4b from "./generated-ff223fb8-d4a5-43a0-adba-f9ee0bfebe42.json";

import a8757776015c2640096102587998035ffb from "./generated-06c792c6-8558-4948-9736-fc3b2a729bfa.json";

import a87c815714b154b9a9755e1eafa7ed723b from "./generated-a83db254-9a9d-4122-a46a-75c5a3d7c03f.json";

import a029d583d60c08c3ea01fd6f965c06914b from "./generated-a0484e40-4f42-46e8-9f71-30c7e6be7806.json";

import aeb64b63db598e2c14ca819855f72dfcfb from "./generated-8341a1a6-0fc4-4013-8606-6c230e8993ca.json";

import a76bcc5f3a25c4b268d405c2562e52362b from "./generated-4282f48b-6bb5-49f3-a711-70b79ad7ccab.json";

import a3e7901d44f49c06f8c320dab5b923cb7b from "./generated-c34d5719-06fc-49e1-88d7-8f721da3e01f.json";

import aeb5e6899cbb4363f688be1e0e3d17558b from "./generated-d9d5a04f-30a7-46a1-8ede-112877f8a915.json";

import af5fd98c29fa3609eef8b26ab1722fcc4b from "./generated-57f86f0c-b9d0-4650-bea6-02eb2c34a1e8.json";

import a2950e91f46eb4f472ed1c3088f03e42eb from "./generated-23bf1b89-320a-4120-9da3-9c0cbe49a8db.json";

import a0fbb127fefee269040a0531f27985e35b from "./generated-f8020e54-912c-4a99-b21c-a7df87682536.json";

import a3c7a75682ca2ae81f871896e2ea61718b from "./generated-8cbbfdfa-bccc-4d4c-99f0-ae02fcf0d98e.json";

import add91fdd1369c844b20bb77fad96e0e75b from "./generated-faa68d7c-097f-41cb-8ba9-58f353179b6c.json";

import a632f390b6e8d03b56b38506220c1a2a4b from "./generated-4a128075-562a-462d-b955-06a39252cd92.json";

import aa22df5120fa9dfd3919140e183534237b from "./generated-111e4420-5c4a-4fb3-928f-8d63c5e4fe5d.json";

import a3c5a136b7a35af2913ec5d6d34045668b from "./generated-28b971e4-d1b5-4d69-88cd-fc0a638a8df5.json";

import a784b1a28d04e1e7d87a341c60d826f1ab from "./generated-13cbbe0e-4865-4fb5-ac34-f00b0524f825.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a98ac30ea0882b9b45a8ceb693ccd4dd4b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a8757776015c2640096102587998035ffb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a87c815714b154b9a9755e1eafa7ed723b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a029d583d60c08c3ea01fd6f965c06914b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aeb64b63db598e2c14ca819855f72dfcfb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a76bcc5f3a25c4b268d405c2562e52362b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a3e7901d44f49c06f8c320dab5b923cb7b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(aeb5e6899cbb4363f688be1e0e3d17558b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(af5fd98c29fa3609eef8b26ab1722fcc4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a2950e91f46eb4f472ed1c3088f03e42eb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a0fbb127fefee269040a0531f27985e35b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a3c7a75682ca2ae81f871896e2ea61718b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af5fd98c29fa3609eef8b26ab1722fcc4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(add91fdd1369c844b20bb77fad96e0e75b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a632f390b6e8d03b56b38506220c1a2a4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(af5fd98c29fa3609eef8b26ab1722fcc4b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(aa22df5120fa9dfd3919140e183534237b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a3c5a136b7a35af2913ec5d6d34045668b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a784b1a28d04e1e7d87a341c60d826f1ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(aa22df5120fa9dfd3919140e183534237b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */